exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleHeight[data-v-56f327b8]{height:24px}@media screen and (max-width:400px){.customerPadding[data-v-56f327b8]{padding-left:1rem;padding-right:1rem}}@media screen and (max-width:382px){.title[data-v-56f327b8]{font-size:16px}.subtitle[data-v-56f327b8]{font-size:11px}.mostPopular[data-v-56f327b8]{font-size:8px}}@media screen and (max-width:359px){.svg[data-v-56f327b8]{display:none}.xxsViewport[data-v-56f327b8]{gap:0}}@media screen and (max-width:356px){.customerPadding[data-v-56f327b8]{padding-left:.75rem;padding-right:.75rem}}@media screen and (max-width:349px){.svg[data-v-56f327b8]{display:none}}", ""]);

// exports
